import { useMemo } from 'react';

export const isSafari = () => /^((?!chrome|android).)*safari/i.test(navigator.userAgent);

export const useIsSafari = () => {
  return useMemo(() => /^((?!chrome|android).)*safari/i.test(navigator.userAgent), []);
};
